<template>
    <ini-badge @close="$emit('close')" v-bind="$props"
               :class="[
               'ini-badge', 'ini-badge__' + name, 
               selected ? 'ini-badge--default ini-badge__' + name + '--' + transformToModifierClass(value) : '' ]">
        <div class="ticket-priority">
            <span :class="['ticket-priority--' + transformToModifierClass(value)]"></span>
            <span class="ticket-priority__label">{{label}}</span>
        </div>
        <slot></slot>
    </ini-badge>
</template>

<script>
    import IniBadge from '@/components/Badge'
    import StyleMixin from '@/mixins/StyleMixin'
    
    export default {
        extends: IniBadge,
        mixins: [StyleMixin],
        
        props: {
            name: String,
            value: String,
            selected: Boolean,
            label: String
        },
        
        components: {
            IniBadge
        },
    }
</script>
